
import api from "../axios";

export const loginAdmin = async (authData) => {
    try {
        const  { data }  = await api.post("/auth/login", authData);
        return data;
    } catch (error) {
        console.log(error.response.data);
        return error.response.data;
    }
}
